import { Modal } from "@/components/elements/Modal";
import { text } from "@/theme/colors";
import { Typography } from "@mui/material";
import { FC } from "react";

type TVisaApprovalUrlModalProps = {
  /** 認証ページ URL。null の間はモーダルを開かない。 */
  approvalUrl: string | null;
  onClose: () => void;
};

// irohana visa の認証ページを開くための確認モーダル。
// 自動でタブを開かず、ここで「同意する」を押させることで挙動を統一する。
// ボタン押下はユーザー操作 (ジェスチャー) なので window.open がブロックされない。
export const VisaApprovalUrlModal: FC<TVisaApprovalUrlModalProps> = ({ approvalUrl, onClose }) => {
  const handleOpen = () => {
    if (approvalUrl) window.open(approvalUrl, "_blank", "noopener,noreferrer");
    onClose();
  };

  return (
    <Modal
      isOpen={!!approvalUrl}
      onClose={onClose}
      onOk={handleOpen}
      title="irohana visa の認証"
      labelOk="同意する"
      width={500}
      hiddenCloseBtn
    >
      <Typography variant="body14" color={text.secondary}>
        irohana visa の認証を行うには、下の同意ボタンを押してください。
      </Typography>
    </Modal>
  );
};
